import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ManagementOrganisation } from '@api/model/managementOrganisation';
import { ManagementApiService } from '@api/service/management.api.service';
import { firstValueFrom, tap } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class OrganisationService {

    private userService = inject(UserService);
    private managementApiService = inject(ManagementApiService);

    private _organisation = signal<ManagementOrganisation|undefined>(undefined);
    organisation$ = toObservable<ManagementOrganisation|undefined>(this._organisation);
    organisation = this._organisation.asReadonly();

    constructor(){

        this.userService.user$.subscribe({
            next: (value) => {

                const org = value?.organisation;

                if(org){
                    console.log("[OrganisationService] Populating Organisation")
                    firstValueFrom(this.getOrganisation(org.id));
                }
                else{
                    console.log("[OrganisationService] Cleaning Organisation")
                    this.cleanOrganisation();
                }
            }
        })

    }
    
    getOrganisation(orgId:number){
        return this.managementApiService.Management.Organisations.Get({
            params: {
                _includeSubData: true,
                filterByIds: [orgId]
            }
        })
        .pipe(
            tap({
                next:(response) => {
                    this._organisation.set(response.result?.at(0));
                }
            })
        )
    }

    cleanOrganisation(){
        this._organisation.set(undefined);
    }
  
}
